var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Price.FCLWeightLimitInformationDetails"),
        width: "340px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "details-view weight-limit-form"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px" } },
          [
            _c(
              "el-button",
              {
                attrs: { no: "onSubmit", type: "primary" },
                on: { click: _vm.onSubmit }
              },
              [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
            ),
            _c(
              "el-button",
              { attrs: { no: "onCancel" }, on: { click: _vm.onCancel } },
              [_vm._v(_vm._s(_vm.$t("Pricing.Cancel")))]
            )
          ],
          1
        ),
        _c("div", { staticStyle: { width: "fit-content" } }, [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        ref: "pol",
                        attrs: { required: "", label: _vm.$t("Pricing.POL") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pol",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.pol,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.pol = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "pod",
                        attrs: { required: "", label: _vm.$t("Pricing.POD") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pod",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.pod,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.pod = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { ref: "via", attrs: { label: _vm.$t("Pricing.Via") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "via",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Seaport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.via,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.via = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "carrier",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.Carrier")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "carrier",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { seaCmp: true },
                            "custom-label": function(item) {
                              return (
                                "[" + item.shortName + "]" + item.chineseName
                              )
                            },
                            "show-custom-label-in-option": true,
                            "default-value": _vm.price.carrier
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.carrier = p.cmpIdx
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "isFrequency",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.DepartureDay")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "isFrequency",
                            disabled: true,
                            value: _vm.isFrequency
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-checkbox", {
                      staticStyle: { "margin-right": "12px" },
                      attrs: { no: "frequency1", label: 1 },
                      model: {
                        value: _vm.price.frequency1,
                        callback: function($$v) {
                          _vm.$set(_vm.price, "frequency1", $$v)
                        },
                        expression: "price.frequency1"
                      }
                    }),
                    _c("el-checkbox", {
                      staticStyle: { "margin-right": "12px" },
                      attrs: { no: "frequency2", label: 2 },
                      model: {
                        value: _vm.price.frequency2,
                        callback: function($$v) {
                          _vm.$set(_vm.price, "frequency2", $$v)
                        },
                        expression: "price.frequency2"
                      }
                    }),
                    _c("el-checkbox", {
                      staticStyle: { "margin-right": "12px" },
                      attrs: { no: "frequency3", label: 3 },
                      model: {
                        value: _vm.price.frequency3,
                        callback: function($$v) {
                          _vm.$set(_vm.price, "frequency3", $$v)
                        },
                        expression: "price.frequency3"
                      }
                    }),
                    _c("el-checkbox", {
                      staticStyle: { "margin-right": "12px" },
                      attrs: { no: "frequency4", label: 4 },
                      model: {
                        value: _vm.price.frequency4,
                        callback: function($$v) {
                          _vm.$set(_vm.price, "frequency4", $$v)
                        },
                        expression: "price.frequency4"
                      }
                    }),
                    _c("el-checkbox", {
                      staticStyle: { "margin-right": "12px" },
                      attrs: { no: "frequency5", label: 5 },
                      model: {
                        value: _vm.price.frequency5,
                        callback: function($$v) {
                          _vm.$set(_vm.price, "frequency5", $$v)
                        },
                        expression: "price.frequency5"
                      }
                    }),
                    _c("el-checkbox", {
                      staticStyle: { "margin-right": "12px" },
                      attrs: { no: "frequency6", label: 6 },
                      model: {
                        value: _vm.price.frequency6,
                        callback: function($$v) {
                          _vm.$set(_vm.price, "frequency6", $$v)
                        },
                        expression: "price.frequency6"
                      }
                    }),
                    _c("el-checkbox", {
                      staticStyle: { "margin-right": "12px" },
                      attrs: { no: "frequency7", label: 7 },
                      model: {
                        value: _vm.price.frequency7,
                        callback: function($$v) {
                          _vm.$set(_vm.price, "frequency7", $$v)
                        },
                        expression: "price.frequency7"
                      }
                    }),
                    _c(
                      "el-form-item",
                      {
                        ref: "eqType",
                        attrs: { required: "", label: _vm.$t("Pricing.EqType") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "eqType",
                            "select-type":
                              _vm.selectTypeNames.basic_data_EQType,
                            "tag-name": "code",
                            clearable: false,
                            "default-value": _vm.price.eqType
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.eqType = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "eqSize",
                        attrs: { required: "", label: _vm.$t("Pricing.EqSize") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "eqSize",
                            "select-type":
                              _vm.selectTypeNames.local_cache_EQSize,
                            "tag-name": "code",
                            clearable: false,
                            "default-value": _vm.price.eqSize
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.eqSize = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "currency",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.Currency")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "currency",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Currency,
                            clearable: false,
                            "default-value": _vm.price.currency
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.price.currency = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.WeightRule") } },
                      [
                        _c("rate-grade", {
                          attrs: {
                            no: "weightRule",
                            "grade-min": _vm.price.gradeMin,
                            "grade-max": _vm.price.gradeMax
                          },
                          on: {
                            onChangeMin: function(p) {
                              _vm.price.gradeMin = p
                            },
                            onChangeMax: function(p) {
                              _vm.price.gradeMax = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Amount") } },
                      [
                        _c("numeric-stepper", {
                          attrs: {
                            no: "amount",
                            "show-tact": false,
                            "show-value": _vm.price.amount
                          },
                          on: {
                            onChangeValue: function(p) {
                              _vm.price.amount = p
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "beginDate",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.BeginDate")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "beginDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.price.beginDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "beginDate", $$v)
                                },
                                expression: "price.beginDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "endDate",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.EndDate")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "endDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.price.endDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.price, "endDate", $$v)
                                },
                                expression: "price.endDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Remarks") } },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "remarks",
                            type: "textarea",
                            maxlength: 255
                          },
                          model: {
                            value: _vm.price.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.price, "remarks", $$v)
                            },
                            expression: "price.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }